// Pill tag — used for brand badges, channel badges, and neutral labels.
// Mirrors the .tag styles from Unified_Inbox_Mockup_v2.html.

import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

export type TagVariant =
  | 'neutral'
  | 'brand-md'
  | 'brand-hk'
  | 'ch-gmail'
  | 'ch-etsy'
  | 'ch-amzn'
  | 'ch-shop'
  | 'ch-ig';

const variantClass: Record<TagVariant, string> = {
  neutral:
    'bg-stone text-ink/70 border border-ink/10',
  'brand-md':
    'bg-monstera text-stone border border-transparent',
  'brand-hk':
    'bg-rose text-ink border border-transparent',
  'ch-gmail':
    'bg-[#FCEBDE] text-[#8A3B10] border border-transparent',
  'ch-etsy':
    'bg-[#FEEEDD] text-[#8A4910] border border-transparent',
  'ch-amzn':
    'bg-[#E9EFF5] text-[#1B3A66] border border-transparent',
  'ch-shop':
    'bg-[#E6EEE3] text-[#2F5A38] border border-transparent',
  'ch-ig':
    'bg-[#F2E5F3] text-[#6B2C6F] border border-transparent',
};

type TagProps = {
  variant?: TagVariant;
  children: ReactNode;
  className?: string;
};

export function Tag({ variant = 'neutral', children, className }: TagProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-pill px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.08em] leading-none',
        variantClass[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
